<template>
  <div class="pardata_box">
    <h3 class="margin">案件详细进度</h3>
    <el-table empty-text="暂无数据" :data="tableData" border>
      <el-table-column label="时间" min-width="50">
        <template slot-scope="scope">
          {{setTime(scope.row.obj.opStart)}}
        </template>
      </el-table-column>
      <el-table-column label="操作方" min-width="50">
        <template slot-scope="scope">
          {{scope.row.passport}}
        </template>
      </el-table-column>
      <el-table-column label="操作细节" min-width="50">
        <template slot-scope="scope">
          {{setTxt(scope.row.obj.opStateText)}}
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="50">
        <template slot-scope="scope">
          {{setStatus(scope.row.obj.extraService).node || '正常进度'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="50">
        <template slot-scope="scope">
          <el-button v-if="scope.row.obj.extraService != 105 && scope.row.obj.extraService != null" type="text" @click='showcooperaterDialogVisible=true;setData(scope.row.obj.extra,scope.row.obj.extraService,scope.row.obj.opPhotoUrls)'>查看内容</el-button>
          <!-- <el-button type="text">查看录音</el-button> -->
        </template>
      </el-table-column>
    </el-table>

	<el-dialog class="dialog" title="查看详情" :visible.sync="showcooperaterDialogVisible" center width="700px" append-to-body>
      <div v-if="serviceId == 109">
        <p>内容：{{jbData.title}}</p>
        <p>详情：{{jbData.detail}}</p>
        <p v-if="opPhotoUrls">录音：
          <a v-for="item in opPhotoUrls" :href="item.url" :download="item.txt">{{item.txt}}</a>
        </p>
      </div>
      <div v-else-if="serviceId == 101 || serviceId == 102 ||serviceId == 103 ||serviceId == 104">
        <p> 加入/离开的人的姓名:{{jbData}}</p>
      </div>
      <div v-else-if='serviceId == 106'>
        <p>录像视频:</p>
        <a href="" download="录像视频">下载</a>
      </div>
      <div v-else-if='serviceId == 107'>
        <p>救助医院:{{jbData.hospital}}</p>
        <p>主治医师联系方式:{{jbData.contact}}</p>
        <p>主治医师名字:{{jbData.doctor}}</p>
      </div>
       <div v-else-if='serviceId == 108'>
        <p>描述:{{jbData.description}} </p>
        <a :href="jbData.url" download="下载">下载</a>
      </div>
      <div v-else-if='serviceId == 110'>
        <p>录音视频:</p>
        <a href="" download="录音视频">下载</a>
      </div>
      <div v-else-if='serviceId == 111'>
        <p>保险责任认定：{{jbData.chinese}} </p>
      </div>
	  <div style="text-align: center;margin-top: 10px;">
	    <el-button type="primary" @click='showcooperaterDialogVisible=false;'>确定</el-button>
	  <el-button  @click='showcooperaterDialogVisible=false;'>取消</el-button>
	  </div>
	</el-dialog>
  </div>
</template>

<script>
  import {
    getCasedetail,
    caseProgress
  } from '@/views/axios/api.js'
  import constants from '@/util/constants.js';
  export default {
    data() {
      return {
        inf: {},
        casenumber: "",
        showcooperaterDialogVisible:false,
        usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
        token: JSON.parse(window.localStorage.getItem("data")).data,
        caseId: this.$route.query.id,
        objdata: {},
        tableData:[],
        jbData:{},
        serviceId:'',
        opPhotoUrls:[],
      }
    },
    props:[
      'caseId1'
    ],
    methods: {
      setTxt(str, status) {
      	if (constants.setTxt(str, status)) {
      		return constants.setTxt(str, status);
      	} else {
      		return str;
      	}
      },
       setTime(str) {
        return constants.time(str)
      },
      setStatus(str){
        return constants.ptXingshitxt3(str)
      },
      getData() {
        var data = {
          token: this.token,
          caseId: this.$route.query.caseId || this.$route.query.id || this.$route.query.caseid || this.caseId || this.caseId1
        }
        caseProgress(data)
          .then(res => {
            console.log(res);
            this.tableData=res.data.obj
          })
          .catch(err => {
            console.log(err);
          })
      },
      setData(obj,id,arr){
        if(id == 101 || id == 102 || id == 103 || id == 104){
          this.jbData=obj
        }else{
          this.jbData=JSON.parse(obj)
        }

        this.serviceId=id;
        this.opPhotoUrls=JSON.parse(arr)
      }
    },

    mounted() {
      this.getData()
    },

  };
</script>


<style scoped>
  a {
    text-decoration: none;
    color: #00abfa;
  }

  .data_wrap {
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
  }

  .data_wrap h3 {
    font-size: 18px;
    color: #333;
    margin: 10px 0;
  }

  .data_wrap ul {
    width: 100%;
    overflow: hidden;
  }

  .data_wrap ul li {
    line-height: 40px;
    font-size: 16px;
    float: left;
    margin-right: 20px;
  }

  .data_wrap ul li:last-child textarea {
    width: 80%;
    height: 80px;
    border: 0;
    border: 1px solid #d9ddde;
    border-radius: 5px;
    font-size: 15px;
    margin-top: 15px;
  }

  .data_wrap ul li:last-child span,
  .data_wrap ul li:last-child textarea {
    float: left;
  }

  .req_box>p {
    margin-top: 15px;
    line-height: 45px;
    text-align: left;
  }

  .box_req ul li b {
    font-size: 14px;
  }

  .org_box {
    font-size: 16px;
    box-sizing: border-box;
    padding-left: 15px;
  }

  .org_box p {
    line-height: 40px;
    color: #333;
  }

  .acc_box {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .acc_box>p {
    color: #333;
    line-height: 40px;
    font-size: 15px;
  }

  .acc_box ul li {
    display: inline-block;
    width: 20%;
    text-align: center;
  }

  .acc_box ul li p {
    text-align: center;
    line-height: 36px;
    height: 36px;
    font-size: 14px;
  }

  .acc_box ul li img {
    width: 90px;
    height: 120px;
  }

  .rescue_box {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .rescue_box>p {
    line-height: 40px;
    font-size: 14px;
  }

  .res_div {
    position: relative;
    top: 18px;
  }

  .res_box {
    position: relative;
    top: 20px;
    font-size: 14px;
    color: #999;
  }

  .el-checkbox-group {
    position: relative;
    box-sizing: border-box;
    padding: 0 15px;
  }

  .el-checkbox {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-checkbox+.el-checkbox {
    margin-left: 0;
  }

  .db_div,
  .res_div {
    font-size: 14px;
    color: #333;
  }

  .db_box {
    font-size: 14px;
    color: #333;
    margin-left: 30px;
  }

  .db_box b {
    color: #ff7200;
    margin-left: 8px;
  }

  .upbtn_box {
    text-align: center;
    margin-top: 0;
  }

  .gl {
    overflow: hidden;
    margin-bottom: 20px;
  }

  .gl li {
    float: left;
    margin-right: 10px;
    line-height: 20px;
  }
  .margin{margin-bottom: 20px;}
  .dialog p{line-height: 2;}
</style>



// WEBPACK FOOTER //
// src/components/par/jianbao.vue